import { HEADER_CONTENT_ACCEPT_JSON } from "../constants/api";
import { HeaderParamsModel } from "../model/common";

export const optionsGet = (url: string, headers: HeaderParamsModel) => {
  return { method: "get", url: url, headers: headers };
};

export const optionsPost = (
  url: string,
  headers: HeaderParamsModel,
  data: any
) => {
  return { method: "post", url: url, headers: headers, data: data };
};

export const getHeadersNoTenant = () => {
  return { ...HEADER_CONTENT_ACCEPT_JSON };
};
export const getHeadersWithTokenOnly = (params: any) => {
  return {
    ...HEADER_CONTENT_ACCEPT_JSON,
    tenant: params.tenantName,
    Authorization: `Bearer ${params.token}`,
  };
};
export const getHeadersWithTokenAndTraderId = (params: any) => {
  return {
    ...HEADER_CONTENT_ACCEPT_JSON,
    tenant: params.tenantName,
    traderId: params.traderId,
    Authorization: `Bearer ${params.token}`,
  };
};

export const getHeaders = (tenantName: string) => {
  return { ...HEADER_CONTENT_ACCEPT_JSON, tenant: tenantName };
};

export const getUrl = (api: string) => {
  return `${process.env.REACT_APP_API}${api}`;
};

export const getSODetails = (params: any) => {
  return {};
};
